export default [
    {
        key: 'creditcard',
        label: 'Credit Card',
        components: [
            {
                type: 'checkbox',
                label: 'Enable Credit Card',
                key: 'creditcard',
                defaultValue: true,
                input: true,
                weight: 150,
                tooltip: 'Check this if you want to allow for Credit Card payments.'
            },
            {
                type: 'checkbox',
                label: 'Enable for single payments',
                key: 'creditcard_once',
                input: true,
                weight: 20,
                tooltip: 'Check this if you want to allow for Credit Card payments when frequency is set to "Once".',
                defaultValue: true,
                customConditional: function customConditional(ctx) {
                    return ctx.data.creditcard;
                }
            },
            {
                type: 'checkbox',
                label: 'Enable for monthly payments',
                key: 'creditcard_monthly',
                input: true,
                weight: 20,
                tooltip: 'Check this if you want to allow for Credit Card payments when frequency is set to "Monthly".',
                defaultValue: true,
                customConditional: function customConditional(ctx) {
                    return ctx.data.creditcard;
                }
            },
            {
                type: 'checkbox',
                label: 'Enable for yearly payments',
                key: 'creditcard_yearly',
                input: true,
                weight: 20,
                tooltip: 'Check this if you want to allow for Credit Card payments when frequency is set to "Yearly".',
                defaultValue: true,
                customConditional: function customConditional(ctx) {
                    return ctx.data.creditcard;
                }
            },
            {
                type: 'textfield',
                label: 'Credit Card label',
                key: 'creditcard_label',
                tooltip: 'Set the label for the Credit Card option',
                input: true,
                allowCalculateOverride: 0,
                defaultValue: 'Credit Card',
                weight: 160,
                customConditional: function customConditional(ctx) {
                    return ctx.data.creditcard;
                }
            },
            {
                weight: 170,
                type: 'datagrid',
                input: true,
                key: 'creditoptions',
                label: 'Credit Card options',
                customConditional: function customConditional(ctx) {
                    return ctx.data.creditcard;
                },
                reorder: true,
                defaultValue: [{
                        value: 'mastercard',
                        logo: 'https://test.adyen.com/hpp/img/pm/mc_small.png',
                        name: 'MasterCard',
                    },
                    {
                        value: 'visa',
                        logo: 'https://test.adyen.com/hpp/img/pm/visa_small.png',
                        name: 'Visa'
                    }],
                components: [{
                        label: 'Label',
                        key: 'name',
                        input: true,
                        type: 'textfield',
                        validate: {
                            required: false
                        }
                    }, {
                        label: 'Brand code',
                        key: 'value',
                        input: true,
                        type: 'textfield',
                        allowCalculateOverride: false,
                        validate: {
                            required: false
                        }
                    }, {
                        label: 'Logo source',
                        key: 'logo',
                        input: true,
                        type: 'textfield',
                        allowCalculateOverride: false,
                    }]
            }
        ]
    },
];
